import { Link } from "react-router-dom";

type SiteLegalFooterProps = {
  /** Use for apply / sign / upload so iframes do not navigate away. */
  openPrivacyInNewTab?: boolean;
  className?: string;
};

/** Compact public legal chrome: © year DealerDog · Privacy Policy · Terms of Use */
export function SiteLegalFooter({
  openPrivacyInNewTab = false,
  className = "",
}: SiteLegalFooterProps) {
  const year = new Date().getFullYear();
  const legalLinkProps = openPrivacyInNewTab
    ? { target: "_blank" as const, rel: "noopener noreferrer" }
    : {};

  return (
    <footer
      className={[
        "text-center text-xs text-gray-500 py-3 px-4",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span>© {year} DealerDog</span>
      <span className="mx-1.5" aria-hidden="true">
        ·
      </span>
      <Link
        to="/privacy"
        className="underline underline-offset-2 hover:text-gray-700"
        {...legalLinkProps}
      >
        Privacy Policy
      </Link>
      <span className="mx-1.5" aria-hidden="true">
        ·
      </span>
      <Link
        to="/terms"
        className="underline underline-offset-2 hover:text-gray-700"
        {...legalLinkProps}
      >
        Terms of Use
      </Link>
    </footer>
  );
}
